import React, { useEffect, useState } from 'react';
import { Modal, Button, Spinner, Alert, ListGroup, Badge } from 'react-bootstrap';
import { getClienteCandidatiMarketplace, confermaClienteMarketplace } from '../services/api';

const nomeCompleto = (c) => c.denominazione_sociale || [c.nome, c.cognome].filter(Boolean).join(' ') || 'Cliente senza nome';
const indirizzoCompleto = (c) => [[c.indirizzo, c.numero_civico].filter(Boolean).join(' '), [c.cap, c.citta].filter(Boolean).join(' '), c.provincia].filter(Boolean).join(', ');
const telefoni = (c) => [c.telefono, c.cellulare].filter(Boolean).join(' / ') || '-';

function SchedaCliente({ cliente, azione }) {
  return (
    <div className="d-flex justify-content-between align-items-start gap-2">
      <div>
        <div className="fw-bold">{nomeCompleto(cliente)} <small className="text-muted">#{cliente.id}</small></div>
        <small className="text-muted d-block">Tel: {telefoni(cliente)}</small>
        <small className="text-muted d-block">{indirizzoCompleto(cliente) || 'Indirizzo non presente'}</small>
        <Badge bg="secondary" className="mt-1">{cliente.n_ordini} {cliente.n_ordini === 1 ? 'ordine' : 'ordini'}</Badge>
      </div>
      {azione}
    </div>
  );
}

function VerificaClienteMarketplaceModal({ ordine, onClose, onResolved }) {
  const [dati, setDati] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!ordine) return;
    setDati(null);
    setError(null);
    setLoading(true);
    getClienteCandidatiMarketplace(ordine.id)
      .then((res) => setDati(res.data))
      .catch((err) => setError(err.response?.data?.detail || 'Errore nel caricamento dei clienti candidati.'))
      .finally(() => setLoading(false));
  }, [ordine]);

  const conferma = async (clienteId) => {
    setSaving(true);
    setError(null);
    try {
      await confermaClienteMarketplace(ordine.id, clienteId);
      onResolved();
    } catch (err) {
      setError(err.response?.data?.detail || 'Errore durante il salvataggio della scelta.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={!!ordine} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Verifica cliente - ordine #{ordine?.id}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <div className="text-center"><Spinner animation="border" /></div>}
        {error && <Alert variant="danger">{error}</Alert>}
        {dati && (
          <>
            <p>Questo ordine è stato importato come nuovo cliente, ma in anagrafica esiste già un cliente con lo stesso cognome e telefono. A quale cliente vuoi collegarlo?</p>
            <h6>Cliente creato dall'import</h6>
            <ListGroup className="mb-3">
              <ListGroup.Item>
                <SchedaCliente
                  cliente={dati.cliente_attuale}
                  azione={<Button size="sm" variant="outline-secondary" disabled={saving} onClick={() => conferma(null)}>Tieni come nuovo cliente</Button>}
                />
              </ListGroup.Item>
            </ListGroup>
            <h6>Clienti già in anagrafica</h6>
            {dati.candidati.length === 0 && <Alert variant="info">Nessun cliente corrispondente trovato (forse già unito).</Alert>}
            <ListGroup>
              {dati.candidati.map((c) => (
                <ListGroup.Item key={c.id}>
                  <SchedaCliente
                    cliente={c}
                    azione={<Button size="sm" variant="success" disabled={saving} onClick={() => conferma(c.id)}>Collega a questo</Button>}
                  />
                </ListGroup.Item>
              ))}
            </ListGroup>
            <small className="text-muted d-block mt-3">Collegando a un cliente esistente, tutti gli ordini del cliente creato dall'import passano a lui e gli ordini futuri dello stesso acquirente IBS/Feltrinelli verranno riconosciuti da soli.</small>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={saving}>Chiudi</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default VerificaClienteMarketplaceModal;
